import http from './httpService';

export function getAllRiskCategories() {
  return http.get(`/risk-categories`);
}

export function createRiskCategory(payload) {
  return http.post(`/risk-categories`, payload);
}

export function updateRiskCategory(payload) {
  return http.put(`/risk-categories`, payload);
}

export function deleteRiskCategory(id) {
  return http.delete(`/risk-categories/${id}`);
}
